import React from "react";
import "./Stepper.scss";
import Container from "../../Container/Container";
import Buttons from "../Button/Button";
import { useSelector } from "react-redux";
import Langtrans from "../Langtrans/Langtrans";
import { useTranslation } from "react-i18next";
import Logo from "../../assets/LAETUS.png";
import { useHistory } from "react-router-dom";
export default function Steppers(props) {
  const login = useSelector((state) => state.login);
  const product = useSelector((state) => state.product);
  const history = useHistory();
  const { t } = useTranslation();

  return (
    <Container>
      {/* <Langtrans login trans /> */}
      <div className="stepper_main">
        <div className="stepper_div">
          <div
            className="stepper_logo cp"
            onClick={() => history.push("/home")}
            style={{ zIndex: 9999 }}
          >
            <img
              src={Logo}
              alt="logo"
              height={130}
              onClick={() => history.push("/home")}
            />
          </div>
          <div
            className="stepper-top"
            style={{
              textAlign: !login.loginStatus && "center",
              width: !login.loginStatus && "100%",
              marginLeft: !login.loginStatus && props.design && "-130px",
            }}
          >
            <div
              style={{
                display: "flex",
                color: `${
                  product.step === 1 || product.step === 2 || product.step === 3
                    ? "#000"
                    : "#C1C1C1"
                }`,
              }}
            >
              <div>
                {t("step")} 1:
                <br />
                {t("create_design")}
              </div>
              <div style={{ width: "90px", margin: "20px", color: "#C1C1C1" }}>
                <hr />
              </div>
            </div>
            <div
              style={{
                display: "flex",
                color: `${
                  product.step === 2 || product.step === 3 ? "#000" : "#C1C1C1"
                }`,
              }}
            >
              <div>
                {t("step")} 2:
                <br />
                {t("set_price")}
              </div>
              <div style={{ width: "90px", margin: "20px", color: "#C1C1C1" }}>
                <hr />
              </div>
            </div>
            <div
              style={{
                display: "flex",
                color: `${product.step === 3 ? "#000" : "#C1C1C1"}`,
              }}
            >
              <div>
                {t("step")} 3:
                <br />
                {t("describe_campaign")}
              </div>
            </div>
          </div>
          {props.login ? (
            <div className="btn ">
              {props.prev ? null : (
                <Buttons text=" < " className="prev" onClick={props.back} />
              )}
              {props.upload && (
                <Buttons
                  text={props.uploadtext}
                  onClick={props.uploadfunc}
                  className="upload-btn "
                />
              )}

              <Buttons
                text={props.text}
                onClick={props.continue}
                loader={props.loader}
              />
            </div>
          ) : null}
        </div>
        <h1>{props.head}</h1>
      </div>
    </Container>
  );
}
